<template>
    <div>
        <div class="panel panel-default -activeseed"
             v-if="activeSeedInfo.length">
            <div class="panel-heading">
                ActiveSeed
            </div>

            <div class="panel-body">
                <dl>
                    <template v-for="info of activeSeedInfo">
                        <dt>{{ infoTitle(info) }}</dt>
                        <dd>{{{ infoValue(info) }}}</dd>
                    </template>
                    <template v-if="client.life_plans &&
                    client.life_plans.length">
                        <dt>Projets de vie</dt>
                        <dd>
                            <span class="badge"
                                  v-for="plan of (client.life_plans || [])">
                                {{ plan }}
                            </span>
                        </dd>
                    </template>
                </dl>
            </div>
        </div>

        <div class="panel panel-default"
             v-if="client.type === 'moral'">
            <a @click.prevent="showEditAddressModal()"
               href="#"
               class="panel-heading">
                Personne morale
                <i class="fa fa-pencil edit-pencil"></i>
            </a>
            <div class="panel-body list-group">
                <div class="list-group-item"
                     v-if="client.address">
                    <a class="-address"
                       target="_blank"
                       :href="addressLink(client.address)">
                            <span>
                                <i class="glyphicon glyphicon-home"></i>
                            </span>
                            <span>
                                {{{ client.address | address }}}
                            </span>
                    </a>
                </div>
                <div class="list-group-item"
                     v-if="!client.address">
                    <div>
                        <em>Pas d'adresse connue</em>
                    </div>
                </div>
            </div>
        </div>

        <contact-box v-for="contact in client.contacts" :contact="contact"
                     :show-edit-modal="showEditModal"></contact-box>

        <div class="add-contact">
            <button class="btn btn-primary btn-sm"
                    @click.prevent="addContact">
                <i class="glyphicon glyphicon-plus"></i>
                Ajouter un contact
            </button>
        </div>

        <modal :show.sync="showModal"
               v-if="showModalHack">
            <div class="modal-header"
                 slot="modal-header">
                <h4 v-if="editContactName">
                    {{ editContact.title | shortTitle }}
                    {{ editContactName }}
                </h4>
                <h4 v-if="!editContactName">
                    Édition/Ajout de contact
                </h4>
            </div>

            <div class="modal-body"
                 slot="modal-body">
                <person-form :data.sync="editContact"
                             :valid.sync="formValid"></person-form>
            </div>

            <div class="modal-footer"
                 slot="modal-footer">
                <button @click.prevent="showModal = false"
                        class="btn btn-link">
                    Annuler
                </button>
                <button @click.prevent="saveContact(editContact)"
                        :class="{disabled: !formValid}"
                        class="btn btn-primary">
                    Sauvegarder
                </button>
            </div>
        </modal>

        <modal :show.sync="showAddressModal"
               v-if="showAddressModalHack">
            <div class="modal-header"
                 slot="modal-header">
                <h4>
                    Personne morale
                </h4>
            </div>

            <div class="modal-body"
                 slot="modal-body">
                <div>
                    <div class="form-group">
                        <label for="clients-add-address{{ idSuffix }}">Adresse</label>
                        <input-address input-class="form-control"
                                       input-id="clients-add-address"
                                       placeholder="Saisir puis choisir une adresse"
                                       :valid.sync="addressValid"
                                       :address.sync="editableAddress"></input-address>
                    </div>
                </div>
            </div>

            <div class="modal-footer"
                 slot="modal-footer">
                <button @click.prevent="showAddressModal = false"
                        class="btn btn-link">
                    Annuler
                </button>
                <button @click.prevent="saveAddress()"
                        :class="{disabled: !addressValid}"
                        class="btn btn-primary">
                    Sauvegarder
                </button>
            </div>
        </modal>
    </div>
</template>

<style lang="less"
       scoped>
    @import '~src/style/variables';

    .panel {
        &:not(.-activeseed) {
            .panel-body {
                padding: 0;
            }
        }

        &.-activeseed {
            dl {
                margin-bottom: 0;
            }
        }
    }

    a.panel-heading {
        display: block;

        &:hover {
             text-decoration: none;
        }
    }

    .edit-pencil {
        visibility: hidden;

        a:hover & {
            visibility: visible;
        }
    }

    .list-group-item {
        padding: 0;

        > * {
            padding: 16px 24px;
        }

        .lgi-inner,
        a {
            display: flex;
            color: @text-color;
        }

        i.glyphicon {
            margin-right: 7px;
        }
    }

    .add-contact {
        text-align: center;
        margin-bottom: @grid-gutter-width;
    }
</style>

<script type="text/ecmascript-6">
    import Vue from 'vue';
    import Modal from 'vue-strap/src/Modal';
    import PersonForm from './PersonForm';
    import InputAddress from '../../components/form/InputAddress';
    import ContactBox from './ContactBox';
    import {items, escape, getAddressLink} from '../../utils';
    import {getAdjectiveDisplay} from '../../api/client';

    export default {
        components: {
            InputAddress,
            Modal,
            ContactBox,
            PersonForm
        },
        props: {
            client: {
                twoWay: true
            }
        },
        data() {
            return {
                showModal: false,
                showModalHack: false,
                showAddressModal: false,
                showAddressModalHack: false,
                editableAddress: {},
                editContact: {},
                state: 'etatcivil',
                addressValid: false,
                formValid: false
            };
        },
        computed: {
            editContactName() {
                return [
                    this.editContact.first_name,
                    this.editContact.last_name
                ].filter((x) => x).join(' ');
            },
            activeSeedInfo() {
                const out = [];

                for (const [k, v] of items(this.client.activeseed)) {
                    if (v) {
                        out.push({
                            slug: k,
                            value: v
                        });
                    }
                }

                return out;
            }
        },
        methods: {
            switchTab(tab) {
                this.tab = tab;
            },
            addressLink(sourceJson) {
                const {formatted_address} = JSON.parse(sourceJson);
                return getAddressLink(formatted_address);
            },
            contactToData(contact) {
                const data = {
                    id: contact.id,
                    first_name: contact.first_name,
                    last_name: contact.last_name,
                    birth_date: contact.birth_date,
                    title: contact.title,
                    info: contact.info.map((i) => {
                        const o = Object.assign({}, i);

                        if (i.type === 'address') {
                            o.value = JSON.parse(i.value);
                        }

                        return o;
                    })
                };

                return data;
            },
            dataToContact(data) {
                const contact = Object.assign({}, data);

                contact.info = data.info.filter((i) => i.value).map((i) => {
                    const o = Object.assign({}, i);

                    if (i.type === 'address') {
                        o.value = JSON.stringify(i.value);
                    }

                    return o;
                });

                if (!contact.birth_date) {
                    contact.birth_date = null;
                }

                return contact;
            },
            addContact() {
                this.showEditModal({
                    title: 'monsieur',
                    info: []
                });
            },
            showEditModal(contact) {
                this.editContact = this.contactToData(contact);
                this.showModal = true;
            },
            saveContact(data) {
                if (!this.formValid) {
                    return;
                }

                const editedContact = this.dataToContact(data);
                const found = this.client.contacts.some((contact) => {
                    if (contact.id === data.id) {
                        Object.assign(contact, editedContact);
                        return true;
                    }
                });

                if (!found) {
                    this.client.contacts.push(editedContact);
                }

                this.showModal = false;
                this.$dispatch('save-client');
            },
            showEditAddressModal() {
                try {
                    this.editableAddress = JSON.parse(this.client.address);
                } catch (e) {
                    this.editableAddress = undefined;
                }

                this.showAddressModal = true;
            },
            saveAddress() {
                this.client.address = JSON.stringify(this.editableAddress) || '';
                this.showAddressModal = false;
                this.$dispatch('save-client');
            },
            infoTitle(info) {
                return ({
                    adjective: 'Caractéristique',
                    as_profile: 'Risque',
                    source: 'Communauté',
                    date_joined: 'Inscription',
                    date_last_seen: 'Connexion',
                    advisor_name: 'Conseiller'
                }[info.slug]) || escape(info.slug);
            },
            infoValue(info) {
                const {date} = Vue.options.filters;

                if (info.slug === 'date_joined' ||
                        info.slug === 'date_last_seen') {
                    return date(info.value, 'lll');
                } else if (info.slug === 'as_profile') {
                    return info.value.replace('_', ' - ');
                } else if (info.slug === 'adjective') {
                    return getAdjectiveDisplay(info.value) ||
                        escape(info.value);
                }

                return escape(info.value);
            }
        },
        watch: {
            showModal() {
                if (this.showModal) {
                    this.showModalHack = true;
                } else {
                    setTimeout(() => this.showModalHack = false, 1000);
                }
            },
            showAddressModal() {
                if (this.showAddressModal) {
                    this.showAddressModalHack = true;
                } else {
                    setTimeout(() => this.showAddressModalHack = false, 1000);
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ContactColumn.vue?368104b0